import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import Button from '@material-ui/core/Button';
import TablePagination from '@material-ui/core/TablePagination';
import Loading from 'layout/Loading';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Scrollbars } from 'react-custom-scrollbars';
import Typography from '@material-ui/core/Typography';

const styles = {
  tableHeader: {
    tableLayout: 'fixed',
    paddingRight: 0,
    borderBottom: '2px groove',
  },
  tableData: {
    tableLayout: 'fixed',
  },
  tableFooter: {
    position: 'absolute',
    bottom: 0,
    borderTop: '1px groove',
  },
  container: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    margin: '0.5em',
    borderStyle: 'solid',
    borderWidth: '1px',
    display: 'flex',
    flexFlow: 'column',
  },
  root: {
    position: 'relative',
    display: 'flex',
    flexFlow: 'column',
    flex: '1 1 auto',
  },
};

export class SearchResults extends Component {
  constructor(props) {
    super(props);

    this.handleChangePage = this.handleChangePage.bind(this);
    this.getSearchTableRows = this.getSearchTableRows.bind(this);
  }

  getSearchTableRows(results) {
    const { classes, setActiveElephant } = this.props;
    const Cell = (text => (
      <TableCell padding="checkbox">
        {text || 'Unknown'}
      </TableCell>
    ));

    return results.map(elephant => (
      <TableRow key={elephant.pk} className={classes.searchRow}>
        {Cell(elephant.name)}
        {Cell(elephant.num)}
        {Cell(elephant.sex)}
        {Cell(elephant.birth)}
        <TableCell padding="checkbox">
          <Button variant="contained" onClick={() => setActiveElephant(elephant.pk)}>
            {'Go to'}
          </Button>
        </TableCell>
      </TableRow>
    ));
  }

  handleChangePage(event, page) {
    const { changePage } = this.props;
    changePage(page);
  }

  render() {
    const {
      classes, searchResult: { results, count }, currentPage, loading, hasSearchedAtleastOnce,
    } = this.props;

    const tableRows = this.getSearchTableRows(results);
    const tableHeaders = ['Name', 'Num', 'Sex', 'Birthday', 'Go to elephant'];
    return (
      <div className={classes.root}>
        <div className={classes.container}>
          <Table className={classes.tableHeader}>
            <TableHead>
              <TableRow className={classes.searchRow}>
                {tableHeaders.map(header => (
                  <TableCell key={header} padding="checkbox">
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
          </Table>
          <Scrollbars style={{ height: 'calc(100% - 114px)' }}>
            {loading ? <Loading /> : (
              tableRows.length > 0
                ? (
                  <Table className={classes.tableData}>
                    <TableBody>
                      {tableRows}
                    </TableBody>
                  </Table>
                )
                : hasSearchedAtleastOnce && (
                <Typography>
                  {'No results matching query'}
                </Typography>))}
          </Scrollbars>
          <Table className={classes.tableFooter}>
            <TableFooter>
              <TableRow>
                <TablePagination
                  disabled
                  count={count}
                  rowsPerPage={20}
                  page={currentPage}
                  backIconButtonProps={{
                    'aria-label': 'Previous Page',
                  }}
                  nextIconButtonProps={{
                    'aria-label': 'Next Page',
                  }}
                  onChangePage={this.handleChangePage}
                  rowsPerPageOptions={[]}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </div>
      </div>
    );
  }
}

SearchResults.propTypes = {
  classes: PropTypes.shape({ root: PropTypes.string }).isRequired,
  searchResult: PropTypes.shape().isRequired,
  loading: PropTypes.bool.isRequired,
  currentPage: PropTypes.number.isRequired,
  changePage: PropTypes.func.isRequired,
  setActiveElephant: PropTypes.func.isRequired,
  hasSearchedAtleastOnce: PropTypes.bool.isRequired,
};

export default withStyles(styles)(SearchResults);



// WEBPACK FOOTER //
// ./src/components/search/SearchResults.jsx